import { render, staticRenderFns } from "./CancelAlertReview.vue?vue&type=template&id=551207b7&"
import script from "./CancelAlertReview.vue?vue&type=script&lang=js&"
export * from "./CancelAlertReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports